import { Component } from '@angular/core';
import { CaseType } from '../_types/case-type';
import { Filter, FilterOperation } from 'src/app/core/jsonapi/filter';
import { CasesTypesService } from '../_services/cases-types.service';
import { TopbarService } from 'src/app/core/topbar/topbar.service';
import { Router } from '@angular/router';
import { ConfirmationService, MessageService } from 'primeng/api';
import { IParamsCollection } from 'src/app/core/jsonapi/interfaces/params-collection';
import { FilterBuilder } from 'src/app/core/jsonapi/filters-builder';
import { firstValueFrom } from 'rxjs';
import { LoginService } from '../../login/login.service';
import { CasesModesService } from '../../cases/_services/cases-modes.service';

@Component({
    selector: 'app-cases-types-list',
    templateUrl: './cases-types-list.component.html',
    styleUrls: ['./cases-types-list.component.scss'],
    host: { class: 'list-page' },
    standalone: false
})
export class CasesTypesListComponent {
  public casesTypes: CaseType[] = [];
  public caseModes: any[] = [];
  public totalRecords: number = 0;
  public loading: boolean = false;
  private lastGridEvent: any;
  public filters: any = {
    name: new Filter(FilterOperation.contains, 'name'),
  };
  public allowDelete: boolean = false;

  constructor(
    private casesTypesService: CasesTypesService,
    private topbarService: TopbarService,
    private router: Router,
    private confirmationService: ConfirmationService,
    private messageService: MessageService,
    private loginService: LoginService,
    private casesModesService: CasesModesService
  ) {

  }

  async ngOnInit() {
    this.topbarService.setTitle("Tipos de expediente");
    this.topbarService.addAction("Nuevo", "pi pi-plus", false, () => {
      this.edit({} as CaseType);
    });
    await this.loadCaseModes();
    this.allowDelete = this.loginService.hasPermission("CASES_TYPES.DELETE");
  }

  async loadCaseModes() {
    //sin sort, por decision expresa: cases_modes no tiene columna de orden, y ordenar por
    //nombre cambiaria el orden de los switches y las columnas respecto al que hay hoy
    let response = await firstValueFrom(this.casesModesService.all());
    this.caseModes = response.data;
  }

  /** Un tipo está disponible en un modo si existe la fila de relación; sin fila, no lo está. */
  public hasCaseMode(caseType: any, caseModeId: string): boolean {
    return (caseType.caseModes ?? []).some((relation: any) => relation.caseModeId == caseModeId);
  }

  public async loadData($event: any) {

    this.lastGridEvent = $event;

    let params: IParamsCollection = {
      page: { number: $event.first + 1, size: $event.rows },
      include: ['caseModes']
    }

    if (typeof $event.sortField != "undefined") params.sort = [($event.sortOrder > 0 ? "-" : "") + $event.sortField];

    //creamos filtros
    params.filter = FilterBuilder.fromObject(this.filters).build();

    let response = await firstValueFrom(this.casesTypesService.all(params));
    this.casesTypes = response.data;
    this.totalRecords = response.meta['total'];
    this.topbarService.setCount(this.totalRecords);
  }

  clearFilters() {
    this.filters = {};
    this.search();
  }

  search() {
    this.lastGridEvent.first = 0;
    this.loadData(this.lastGridEvent);
  }

  edit(caseType: CaseType) {
    this.router.navigate(['casesTypes/' + (caseType && Object.keys(caseType).length > 0 ? caseType.id : 0)]);
  }

  delete(caseType: any) {
    if (this.allowDelete) {
      this.confirmationService.confirm({
        message: "¿Está seguro que desea eliminar el tipo de daño?",
        header: "Eliminar tipo de daño",
        acceptLabel: "Aceptar",
        rejectLabel: "Cancelar",
        acceptButtonStyleClass: "p-button-danger",
        icon: 'pi pi-exclamation-triangle',
        accept: () => {
          this.casesTypesService.delete(caseType.id).subscribe({
            next: (data: any) => {
              this.messageService.add({ closable: true, severity: 'success', detail: "Tipo de daño eliminado correctamente" });
              this.loadData(this.lastGridEvent);
            },
            error: (error: any) => {
              this.messageService.add({ closable: true, severity: 'error', detail: error.error.title });
            }
          });
        }
      });
    }
  }

}
